import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Dropdown } from 'primereact/dropdown';

import { viewedUnviewedOptions } from 'constants/automation';
import { RequiredValidation } from 'components/UI/RequiredValidation/RequiredValidation';

const IsViewedFilter = ({ index }) => {
  const {
    formState: { errors },
    control,
  } = useFormContext();

  return (
    <div className="me-2 flex-grow-1">
      <Controller
        name={`filters.${index}.value`}
        control={control}
        rules={{ required: 'Value is required' }}
        render={({ field }) => (
          <Dropdown
            options={viewedUnviewedOptions}
            value={field.value?.is_viewed}
            onChange={(e) => field.onChange({ is_viewed: e.value })}
            placeholder="Select Value"
            isFilter={true}
            className="input-shadow w-100"
            display="chip"
            inputRef={field.ref}
          />
        )}
      />
      <RequiredValidation field={`filters.${index}.value`} errors={errors} />
    </div>
  );
};

export default IsViewedFilter;
